'use client';

import React, { useState } from 'react';
import { Plus, Search, Filter, Package, Eye, Edit2, FileText, CheckCircle, AlertTriangle,  } from 'lucide-react';
import StatusBadge from '@/components/ui/StatusBadge';

import Modal from '@/components/ui/Modal';
import LotDetailDrawer from './LotDetailDrawer';
import CreateLotForm from './CreateLotForm';

const LOTS_DATA = [
  {
    id: 'lot-300',
    lotNumber: '300',
    product: 'Onion',
    distributor: 'Rajesh Traders',
    distributorMobile: '9876543210',
    distributorCity: 'Nashik',
    arrivalDate: '16/06/2026',
    totalBags: 200,
    totalWeight: 10000,
    soldBags: 148,
    soldWeight: 7400,
    status: 'active' as const,
    officialGrades: { A: 60, B: 90, C: 50 },
    dealerGrades: { A: 55, B: 95, C: 50 },
    docsCount: 3,
    salesValue: 222000,
    expenseTotal: 12400,
    paymentsReceived: 185000,
    remarks: 'Good quality batch from Nashik',
  },
  {
    id: 'lot-470',
    lotNumber: '470',
    product: 'Potato',
    distributor: 'Mahesh Agro',
    distributorMobile: '9845621370',
    distributorCity: 'Agra',
    arrivalDate: '17/06/2026',
    totalBags: 150,
    totalWeight: 7500,
    soldBags: 62,
    soldWeight: 3100,
    status: 'active' as const,
    officialGrades: { A: 80, B: 50, C: 20 },
    dealerGrades: { A: 75, B: 55, C: 20 },
    docsCount: 2,
    salesValue: 93000,
    expenseTotal: 8200,
    paymentsReceived: 45000,
    remarks: 'Standard quality',
  },
  {
    id: 'lot-211',
    lotNumber: '211',
    product: 'Tomato',
    distributor: 'Suresh Farm',
    distributorMobile: '9912345678',
    distributorCity: 'Kolar',
    arrivalDate: '14/06/2026',
    totalBags: 100,
    totalWeight: 5000,
    soldBags: 100,
    soldWeight: 5000,
    status: 'pending' as const,
    officialGrades: { A: 40, B: 40, C: 20 },
    dealerGrades: { A: 35, B: 42, C: 23 },
    docsCount: 4,
    salesValue: 175000,
    expenseTotal: 9800,
    paymentsReceived: 162500,
    remarks: 'Fully sold — settlement pending',
  },
  {
    id: 'lot-410',
    lotNumber: '410',
    product: 'Garlic',
    distributor: 'Prakash Exports',
    distributorMobile: '9700123456',
    distributorCity: 'Madhya Pradesh',
    arrivalDate: '15/06/2026',
    totalBags: 80,
    totalWeight: 4000,
    soldBags: 35,
    soldWeight: 1750,
    status: 'active' as const,
    officialGrades: { A: 50, B: 20, C: 10 },
    dealerGrades: { A: 48, B: 22, C: 10 },
    docsCount: 2,
    salesValue: 87500,
    expenseTotal: 5600,
    paymentsReceived: 60000,
    remarks: 'Premium garlic — high demand',
  },
  {
    id: 'lot-185',
    lotNumber: '185',
    product: 'Onion',
    distributor: 'Kumar Brothers',
    distributorMobile: '9988776655',
    distributorCity: 'Pune',
    arrivalDate: '12/06/2026',
    totalBags: 180,
    totalWeight: 9000,
    soldBags: 180,
    soldWeight: 9000,
    status: 'pending' as const,
    officialGrades: { A: 70, B: 80, C: 30 },
    dealerGrades: { A: 68, B: 82, C: 30 },
    docsCount: 5,
    salesValue: 315000,
    expenseTotal: 18200,
    paymentsReceived: 270000,
    remarks: 'Fully sold, awaiting final payment',
  },
  {
    id: 'lot-092',
    lotNumber: '092',
    product: 'Potato',
    distributor: 'Srinivas Agro',
    distributorMobile: '9654321098',
    distributorCity: 'Shimla',
    arrivalDate: '10/06/2026',
    totalBags: 120,
    totalWeight: 6000,
    soldBags: 120,
    soldWeight: 6000,
    status: 'settled' as const,
    officialGrades: { A: 60, B: 40, C: 20 },
    dealerGrades: { A: 58, B: 42, C: 20 },
    docsCount: 6,
    salesValue: 228000,
    expenseTotal: 14100,
    paymentsReceived: 228000,
    remarks: 'Settled — closed',
  },
  {
    id: 'lot-058',
    lotNumber: '058',
    product: 'Tomato',
    distributor: 'Ravi Farm Produce',
    distributorMobile: '9123456780',
    distributorCity: 'Bangalore',
    arrivalDate: '08/06/2026',
    totalBags: 90,
    totalWeight: 4500,
    soldBags: 90,
    soldWeight: 4500,
    status: 'closed' as const,
    officialGrades: { A: 45, B: 30, C: 15 },
    dealerGrades: { A: 44, B: 31, C: 15 },
    docsCount: 7,
    salesValue: 157500,
    expenseTotal: 9200,
    paymentsReceived: 157500,
    remarks: 'Closed successfully',
  },
  {
    id: 'lot-330',
    lotNumber: '330',
    product: 'Ginger',
    distributor: 'Anand Spice Traders',
    distributorMobile: '9876012345',
    distributorCity: 'Kerala',
    arrivalDate: '18/06/2026',
    totalBags: 60,
    totalWeight: 3000,
    soldBags: 0,
    soldWeight: 0,
    status: 'arrived' as const,
    officialGrades: { A: 30, B: 20, C: 10 },
    dealerGrades: { A: 0, B: 0, C: 0 },
    docsCount: 1,
    salesValue: 0,
    expenseTotal: 2400,
    paymentsReceived: 0,
    remarks: 'Just arrived — grading pending',
  },
];

const STATUS_FILTERS = ['All', 'Arrived', 'Active', 'Pending', 'Settled', 'Closed'];
const PRODUCT_FILTERS = ['All Products', 'Onion', 'Potato', 'Tomato', 'Garlic', 'Ginger'];

export default function LotManagementClient() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [productFilter, setProductFilter] = useState('All Products');
  const [selectedLot, setSelectedLot] = useState<typeof LOTS_DATA[0] | null>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const filtered = LOTS_DATA.filter((lot) => {
    const matchSearch =
      lot.lotNumber.includes(search) ||
      lot.product.toLowerCase().includes(search.toLowerCase()) ||
      lot.distributor.toLowerCase().includes(search.toLowerCase());
    const matchStatus = statusFilter === 'All' || lot.status === statusFilter.toLowerCase();
    const matchProduct = productFilter === 'All Products' || lot.product === productFilter;
    return matchSearch && matchStatus && matchProduct;
  });

  return (
    <div className="space-y-4">
      {/* Header actions */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex-1 relative w-full sm:w-auto">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by lot number, product, distributor..."
            className="input-field pl-9"
          />
        </div>
        <button
          onClick={() => setShowCreateModal(true)}
          className="btn-primary whitespace-nowrap"
        >
          <Plus size={16} />
          New Lot
        </button>
      </div>

      {/* Filter chips */}
      <div className="flex gap-2 overflow-x-auto scrollbar-none pb-1">
        {STATUS_FILTERS.map((f) => (
          <button
            key={`status-filter-${f}`}
            onClick={() => setStatusFilter(f)}
            className={`flex-shrink-0 text-xs font-medium px-3 py-1.5 rounded-lg border transition-all ${
              statusFilter === f
                ? 'bg-primary/10 text-primary border-primary/30' :'bg-muted text-muted-foreground border-border hover:border-primary/30'
            }`}
          >
            {f}
          </button>
        ))}
        <div className="w-px bg-border flex-shrink-0 mx-1" />
        {PRODUCT_FILTERS.map((f) => (
          <button
            key={`product-filter-${f}`}
            onClick={() => setProductFilter(f)}
            className={`flex-shrink-0 text-xs font-medium px-3 py-1.5 rounded-lg border transition-all ${
              productFilter === f
                ? 'bg-primary/10 text-primary border-primary/30' :'bg-muted text-muted-foreground border-border hover:border-primary/30'
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Summary stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[
          { label: 'Total Lots', value: LOTS_DATA.length.toString() },
          { label: 'Active', value: LOTS_DATA.filter(l => l.status === 'active').length.toString() },
          { label: 'Pending Settlement', value: LOTS_DATA.filter(l => l.status === 'pending').length.toString() },
          { label: 'Closed Today', value: '1' },
        ].map((stat) => (
          <div key={`lot-stat-${stat.label}`} className="card-base p-3 text-center">
            <p className="text-lg font-bold text-foreground">{stat.value}</p>
            <p className="text-2xs text-muted-foreground">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="card-base overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead className="bg-muted/30 border-b border-border">
              <tr>
                <th className="table-header-cell">Lot #</th>
                <th className="table-header-cell">Product</th>
                <th className="table-header-cell">Distributor</th>
                <th className="table-header-cell">Arrival</th>
                <th className="table-header-cell">Bags</th>
                <th className="table-header-cell">Weight (kg)</th>
                <th className="table-header-cell">Sold %</th>
                <th className="table-header-cell">Grade Match</th>
                <th className="table-header-cell">Status</th>
                <th className="table-header-cell">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((lot) => {
                const soldPct = Math.round((lot.soldBags / lot.totalBags) * 100);
                const gradeVariance = Math.abs(lot.dealerGrades.A - lot.officialGrades.A);
                const hasVariance = gradeVariance > 3;
                return (
                  <tr
                    key={lot.id}
                    className="table-row"
                    onClick={() => { setSelectedLot(lot); setDrawerOpen(true); }}
                  >
                    <td className="table-cell">
                      <span className="lot-number font-bold text-primary">#{lot.lotNumber}</span>
                    </td>
                    <td className="table-cell">
                      <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center">
                          <Package size={12} className="text-primary" />
                        </div>
                        <span className="font-medium">{lot.product}</span>
                      </div>
                    </td>
                    <td className="table-cell">
                      <div>
                        <p className="font-medium text-foreground">{lot.distributor}</p>
                        <p className="text-2xs text-muted-foreground">{lot.distributorCity}</p>
                      </div>
                    </td>
                    <td className="table-cell text-muted-foreground">{lot.arrivalDate}</td>
                    <td className="table-cell">
                      <span className="font-semibold">{lot.totalBags}</span>
                      <span className="text-muted-foreground text-xs"> bags</span>
                    </td>
                    <td className="table-cell amount-display">
                      {lot.totalWeight.toLocaleString('en-IN')}
                    </td>
                    <td className="table-cell">
                      <div className="flex items-center gap-2">
                        <div className="w-16 bg-muted rounded-full h-1.5">
                          <div
                            className={`h-1.5 rounded-full ${soldPct === 100 ? 'bg-accent' : 'bg-primary'}`}
                            style={{ width: `${soldPct}%` }}
                          />
                        </div>
                        <span className="text-xs font-medium">{soldPct}%</span>
                      </div>
                    </td>
                    <td className="table-cell">
                      {hasVariance ? (
                        <span className="flex items-center gap-1 text-warning text-xs font-medium">
                          <AlertTriangle size={11} />
                          ±{gradeVariance} bags
                        </span>
                      ) : (
                        <span className="flex items-center gap-1 text-accent text-xs font-medium">
                          <CheckCircle size={11} />
                          Match
                        </span>
                      )}
                    </td>
                    <td className="table-cell">
                      <StatusBadge status={lot.status} />
                    </td>
                    <td className="table-cell" onClick={(e) => e.stopPropagation()}>
                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => { setSelectedLot(lot); setDrawerOpen(true); }}
                          className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
                          title="View lot details"
                        >
                          <Eye size={14} />
                        </button>
                        <button
                          className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
                          title="Edit lot"
                        >
                          <Edit2 size={14} />
                        </button>
                        <button
                          className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
                          title="View documents"
                        >
                          <FileText size={14} />
                          {lot.docsCount > 0 && (
                            <span className="text-2xs text-primary">{lot.docsCount}</span>
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Showing {filtered.length} of {LOTS_DATA.length} lots
          </p>
          <div className="flex items-center gap-1">
            {[1, 2, 3].map((page) => (
              <button
                key={`page-${page}`}
                className={`w-7 h-7 rounded-lg text-xs font-medium transition-colors ${
                  page === 1
                    ? 'bg-primary/10 text-primary border border-primary/30' :'text-muted-foreground hover:bg-muted'
                }`}
              >
                {page}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Lot Detail Drawer */}
      {selectedLot && (
        <LotDetailDrawer
          lot={selectedLot}
          isOpen={drawerOpen}
          onClose={() => { setDrawerOpen(false); setSelectedLot(null); }}
        />
      )}

      {/* Create Lot Modal */}
      <Modal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title="Create New Lot"
        size="lg"
      >
        <CreateLotForm onClose={() => setShowCreateModal(false)} />
      </Modal>
    </div>
  );
}